'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X, Heart } from 'lucide-react';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Find a Healer', href: '/find-healers' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'For Healers', href: '/healer-onboarding' },
  { label: 'Book Consultation', href: '/book-consultation' },
  { label: 'About', href: '#about' },
];

export default function PublicHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-sm border-b border-border shadow-nav">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2.5 group">
          <AppLogo size={36} />
          <div className="flex flex-col leading-none">
            <span className="font-bold text-base text-foreground tracking-tight">Healing52</span>
            <span className="text-[10px] font-medium text-muted-foreground tracking-wide">Relationship Healing</span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {navLinks?.map((link) => (
            <Link
              key={`nav-${link?.label}`}
              href={link?.href}
              className="px-3.5 py-2 rounded-lg text-sm font-medium text-muted-foreground hover:text-primary hover:bg-primary/5 transition-all duration-150"
            >
              {link?.label}
            </Link>
          ))}
        </nav>

        {/* Desktop Actions */}
        <div className="hidden lg:flex items-center gap-3">
          <Link
            href="/sign-up-login-screen"
            className="px-4 py-2 text-sm font-semibold text-primary border border-primary rounded-lg hover:bg-primary/5 transition-all duration-150 active:scale-95"
          >
            Login
          </Link>
          <Link
            href="/sign-up-login-screen"
            className="px-4 py-2 text-sm font-semibold text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 transition-all duration-150 active:scale-95 flex items-center gap-1.5"
          >
            <Heart size={14} />
            Get Started
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="lg:hidden p-2 rounded-lg text-muted-foreground hover:text-primary hover:bg-primary/5 transition-all"
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile Drawer */}
      {mobileOpen && (
        <div className="lg:hidden border-t border-border bg-card px-6 py-4 flex flex-col gap-1 fade-in">
          {navLinks?.map((link) => (
            <Link
              key={`mobile-nav-${link?.label}`}
              href={link?.href}
              onClick={() => setMobileOpen(false)}
              className="px-3 py-2.5 rounded-lg text-sm font-medium text-muted-foreground hover:text-primary hover:bg-primary/5 transition-all"
            >
              {link?.label}
            </Link>
          ))}
          <div className="flex gap-3 mt-3 pt-3 border-t border-border">
            <Link
              href="/sign-up-login-screen"
              onClick={() => setMobileOpen(false)}
              className="flex-1 text-center px-4 py-2.5 text-sm font-semibold text-primary border border-primary rounded-lg hover:bg-primary/5 transition-all"
            >
              Login
            </Link>
            <Link
              href="/sign-up-login-screen"
              onClick={() => setMobileOpen(false)}
              className="flex-1 text-center px-4 py-2.5 text-sm font-semibold text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 transition-all"
            >
              Get Started
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}